import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiBenefitsOpenEnrollmentAvailableQueryResponse,
  GetApiBenefitsOpenEnrollmentAvailableQueryParams,
  GetApiBenefitsOpenEnrollmentAvailable401,
  GetApiBenefitsOpenEnrollmentAvailable403,
} from "../../../types/GetApiBenefitsOpenEnrollmentAvailable";

export function getGetApiBenefitsOpenEnrollmentAvailableUrl() {
  return `/api/Benefits/open-enrollment-available` as const;
}

/**
 * {@link /api/Benefits/open-enrollment-available}
 */
export async function getApiBenefitsOpenEnrollmentAvailable(
  params?: GetApiBenefitsOpenEnrollmentAvailableQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiBenefitsOpenEnrollmentAvailableQueryResponse,
    ResponseErrorConfig<
      | GetApiBenefitsOpenEnrollmentAvailable401
      | GetApiBenefitsOpenEnrollmentAvailable403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiBenefitsOpenEnrollmentAvailableUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
